import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' }
      ]
    },
    clientName: {
      validations: []
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    theme: {
      validations: []
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' },
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    startTime: {
      validations: []
    },
    addressLine1: {
      validations: [
        { type: 'required', message: 'Please fill the required field.' },
      ]
    },
    eventExtra1: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    eventExtra2: {
      validations: []
    },
    notes: {
      validations: []
    },
    reference: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Your First Name (required)',
            mapping: 'firstName'
          },
        ]
      },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Your Last Name (required)',
           mapping: 'lastName'
         }
       ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Your Company',
            mapping: 'clientName'
          },
         ]
        },
      {
        fields: [
         {
           type: 'text',
           size: 'Medium',
           label: 'Your Phone (required)',
           mapping: 'telnumber'
         }
       ]
     },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Your Email (required)',
            mapping: 'email'
          },
         ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Type of Event',
              mapping: 'theme'
            },
           ]
          },
        {
          fields: [
            {
              type: 'date-picker',
              size: 'Medium',
              label: 'Event Date (required)',
              mapping: 'eventDate'
            }
          ]
        },
        {
          fields: [
            {
              type: 'multiple-choice',
              size: 'Medium',
              label: 'Event Time',
              options: [
                { label: '7:30 AM', value: '07:30:00' },
                { label: '8:00 AM', value: '08:00:00' },
                { label: '8:30 AM', value: '08:30:00' },
                { label: '9:00 AM', value: '09:00:00' },
                { label: '9:30 AM', value: '09:30:00' },
                { label: '10:00 AM', value: '10:00:00' },
                { label: '10:30 AM', value: '10:30:00' },
                { label: '11:00 AM', value: '11:00:00' },
                { label: '11:30 AM', value: '11:30:00' },
                { label: '12:00 PM', value: '12:00:00' },
                { label: '12:30 PM', value: '12:30:00' },
                { label: '1:00 PM', value: '13:00:00' },
                { label: '1:30 PM', value: '13:30:00' },
                { label: '2:00 PM', value: '14:00:00' },
                { label: '2:30 PM', value: '14:30:00' },
                { label: '3:00 PM', value: '15:00:00' },
                { label: '3:30 PM', value: '15:30:00' },
                { label: '4:00 PM', value: '16:00:00' },
                { label: '4:30 PM', value: '16:30:00' },
                { label: '5:00 PM', value: '17:00:00' },
                { label: '5:30 PM', value: '17:30:00' },
                { label: '6:00 PM', value: '18:00:00' },
                { label: '6:30 PM', value: '18:30:00' },
                { label: '7:00 PM', value: '19:00:00' },
                { label: '7:30 PM', value: '19:30:00' },
                { label: '8:00 PM', value: '20:00:00' },
                { label: '8:30 PM', value: '20:30:00' },
                { label: '9:00 PM', value: '21:00:00' },
                { label: '9:30 PM', value: '21:30:00' },
                { label: '10:00 PM', value: '22:00:00' },
                { label: '10:30 PM', value: '22:30:00' },
                { label: '11:00 PM', value: '23:00:00' },
                { label: '11:30 PM', value: '23:30:00' },
                { label: '12:00 AM (next day)', value: '00:00:00' },
                { label: '12:30 AM (next day)', value: '00:30:00' },
                { label: '1:00 AM (next day)', value: '01:00:00' },
                { label: '1:30 AM (next day)', value: '01:30:00' },
                { label: '2:00 AM (next day)', value: '02:00:00' },
                { label: '2:30 AM (next day)', value: '02:30:00' }
              ],
              mapping: 'startTime'
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Event Venue booked or In Mind (required)',
              mapping: 'addressLine1'
            }
          ]
        },
        {
          fields: [
            {
              type: 'text',
              size: 'Medium',
              label: 'Budget for Food and Service',
              mapping: 'eventExtra1'
            }
          ]
        },
          {
            fields: [
              {
                type: 'text',
                size: 'Medium',
                label: 'Number of Guests',
                mapping: 'plannedguestcount'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'Service Style',
                options: [
                  { label: 'Buffet', value: 'Buffet' },
                  { label: 'Plated', value: 'Plated' },
                  { label: 'Stations', value: 'Stations' },
                  { label: 'Family Style', value: 'Family Style' },
                  { label: 'Cocktail', value: 'Cocktail' },
                  { label: 'Other', value: 'Other' },
                ],
                mapping: 'eventExtra2'
              }
            ]
          },
          {
            fields: [
              {
                type: 'text-area',
                size: 'Medium',
                label: 'Additional Info',
                mapping: 'notes'
              }
            ]
          },
          {
            fields: [
              {
                type: 'multiple-choice',
                size: 'Medium',
                label: 'How did you hear about us?',
                options: [
                  { label: 'Google Search', value: 'Google Search' },
                  { label: 'Wedding Wire', value: 'Wedding Wire' },
                  { label: 'The Knot', value: 'The Knot' },
                  { label: 'Savannah Wedding Magazine', value: 'Savannah Wedding Magazine' },
                  { label: 'Personal Referral', value: 'Personal Referral' },
                  { label: 'Professional Referral', value: 'Professional Referral' },
                  { label: 'Facebook', value: 'Facebook' },
                  { label: 'Pinterest', value: 'Pinterest' },
                  { label: 'Other', value: 'Other' }
                ],
                mapping: 'reference'
              }
            ]
          },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Thrive Catering Contact Form',
    formId: '508',
    clientKey: '4ABE4313-9B75-49BC-BE7C-14269FE6D78C',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/thrive/form_structure.js